module.exports={select:"Выбрать",selected:"Выбрано"};